export default {
      id: "share-usage",
      viewBox: "0 0 265.86 188.39",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#share-usage",
      toString: function () {
        return this.url;
      }
    }